import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
    errorAppNotToConsider?: boolean;
    errorValidateGroup?: boolean;
    errorDentalKids?: boolean;
    errorDentalAdults?: boolean;
    customError?: string;
}

export default function CustomGroupingFailureModal({
    closeModal,
    errorAppNotToConsider,
    errorValidateGroup,
    errorDentalKids,
    errorDentalAdults,
    customError,
}: IModalProps) {

    const failureMessages = [
        {
            condition: errorAppNotToConsider,
            text: 'customGrouping.error.appNotToConsider',
        },
        {
            condition: errorValidateGroup,
            text: 'customGrouping.error.validateGroup',
        },
        {
            condition: errorDentalKids,
            text: 'customGrouping.error.dentalKids',
        },
        {
            condition: errorDentalAdults,
            text: 'customGrouping.error.dentalAdult',
        },
        {
            condition: !!customError,
            text: customError,
        },
    ];

    function onClose(e) {
        e?.preventDefault();
        closeModal('customGroupingFailure');
    }

    return (
        <Modal id="customGroupingFailureModal">
            <Modal.Header
                id="customGroupingFailureModalHeader"
                titleId="customGrouping.customGrouping"
                onHide={onClose}
            />
            <Modal.Body id="customGroupingFailureModalBody">
                <>
                    {failureMessages.map((config, index) => (
                        <ConditionalRendering isTrue={config.condition} key={index}>
                            <p key={index}>
                                <FormattedMessage id={config.text} />
                            </p>
                        </ConditionalRendering>
                    ))}
                </>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="customGroupingFailureModalCloseButton" 
                    onClickHandler={onClose} 
                    variant="secondary" 
                    labelId="button.close" 
                />
            </Modal.Controls>
        </Modal>
    );
}
